import { abortable as abortableBase } from "@enfusion-ui/utils";
import queryString from "query-string";
export default (restServer) => {
    const abortable = (c) => abortableBase(restServer, c);
    return {
        FAST_SEARCH: (query) => restServer(queryString.stringifyUrl({
            url: "/internal/api/instrument/search/fast",
            query: {
                ...query,
                financialSubTypes: query?.financialSubTypes?.join(",") ?? undefined,
            },
        })),
        GET_INSTRUMENT_INFO: (instrumentId) => restServer(`/internal/api/instrument/${instrumentId}`),
        GET_CURRENCY_PAIR: (instrumentId) => restServer(`/internal/api/instrument/${instrumentId}`),
        GET_CURRENCY_PAIR_PATH: (instrumentId) => `/internal/api/instrument/${instrumentId}`,
        GET_CURRENCY_PAIRS_PATH: () => "/internal/api/instrument/currencies/pairs",
        GET_SETTLEMENT_CURRENCIES: () => restServer("/internal/api/instrument/currencies"),
        GET_SETTLEMENT_CURRENCIES_PATH: () => "/internal/api/instrument/currencies",
        GET_CDX_ROOTS_PATH: () => "/internal/api/instrument/cdx/roots",
        GET_QUICK_TEMPLATES: () => "/internal/api/instrument/irs/templates",
        GET_CDX_INSTRUMENT: (cdxRoot, otrOnly) => restServer(`/internal/api/instrument/cdx?cdxRoot=${cdxRoot}&otrOnly=${otrOnly}`),
        GET_FRONT_MONTH_FUTURE: abortable((instrumentId) => queryString.stringifyUrl({
            url: "/internal/api/instrument/frontMonthFuture",
            query: { instrumentId },
        })),
    };
};
